function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import ro from "../util/browser-detector.js";
import Gt from "../models/device.js";
import DeviceProperties from "../Core/device-properties.js";
import _t from "../models/identifier.js";
import { logger as N, Guid as K } from "../../shared-lib/index.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import { values as Rt } from "../util/code-utils.js";
import { getErrorMessage as si } from "../util/error-utils.js";

var Ot = /*#__PURE__*/function () {
  function Ot(t, e) {
    _classCallCheck(this, Ot);

    this.C = t, this.Qa = e, this.C = t, null == e && (e = Rt(DeviceProperties)), this.Qa = e;
  }

  _createClass(Ot, [{
    key: "ve",
    value: function ve() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      var e = this.C.tu(s.iu.Na);
      null == e && (e = new _t(K.ce()), t && this.C.uu(s.iu.Na, e));
      var r = new Gt(e.eu);

      for (var _t2 = 0; _t2 < this.Qa.length; _t2++) {
        switch (this.Qa[_t2]) {
          case DeviceProperties.BROWSER:
            r.browser = ro.browser;
            break;

          case DeviceProperties.BROWSER_VERSION:
            r.tc = ro.version;
            break;

          case DeviceProperties.OS:
            r.os = this.ec();
            break;

          case DeviceProperties.RESOLUTION:
            r.rc = screen.width + "x" + screen.height;
            break;

          case DeviceProperties.LANGUAGE:
            r.language = ro.language;
            break;

          case DeviceProperties.TIME_ZONE:
            r.timeZone = this.sc(new Date());
            break;

          case DeviceProperties.USER_AGENT:
            r.userAgent = ro.userAgent;
        }
      }

      return r;
    }
  }, {
    key: "ec",
    value: function ec() {
      if (ro.ic()) return ro.ic();
      var t = this.C.ft(s.gt.oc);
      return t && t.os_version ? t.os_version : ro.ec();
    }
  }, {
    key: "sc",
    value: function sc(t) {
      var e = !1;
      if ("undefined" != typeof Intl && "function" == typeof Intl.DateTimeFormat) try {
        if ("function" == typeof Intl.DateTimeFormat().resolvedOptions) {
          var _t3 = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (null != _t3 && "" !== _t3) return _t3;
        }
      } catch (t) {
        N.info("Intl.DateTimeFormat threw an error, cannot detect user's time zone:" + si(t)), e = !0;
      }
      if (e) return "";
      var r = t.getTimezoneOffset();
      return this.nc(r);
    }
  }, {
    key: "nc",
    value: function nc(t) {
      var e = Math.trunc(t / 60),
          r = Math.trunc(t % 60);
      var s = "GMT";
      return 0 !== t && (s += t < 0 ? "+" : "-", s += ("00" + Math.abs(e)).slice(-2) + ":" + ("00" + Math.abs(r)).slice(-2)), s;
    }
  }]);

  return Ot;
}();

export { Ot as default };